import * as actionTypes from "./actionTypes";

export const chattyLoad = (callback = () => {}) => {
  return {
    type: actionTypes.CHATTY_LOAD,
    callback,
  };
};

export const chattySaveChats = (chats) => {
  return {
    type: actionTypes.CHATTY_SAVE_CHATS,
    chats,
  };
};

export const chattyGetMessages = (chattyId, callback = () => {}) => {
  return {
    type: actionTypes.CHATTY_GET_MESSAGES,
    chattyId,
    callback,
  };
};

export const chattySaveMessages = (chattyId, messages) => {
  return {
    type: actionTypes.CHATTY_SAVE_MESSAGES,
    chattyId,
    messages,
  };
};

export const chattySendMessage = (chattyId, message, callback = () => {}) => {
  return {
    type: actionTypes.CHATTY_SEND_MESSAGE,
    chattyId,
    message,
    callback,
  };
};

export const chattyGetEarnings = (chattyId, callback = () => {}) => {
  return {
    type: actionTypes.CHATTY_GET_EARNINGS,
    chattyId,
    callback,
  };
};
